import React from 'react'
import { presenceErrorClass } from 'servos/formValidations'

class SuburbLookup extends React.Component {

  suburbFinder = () => {
    this.widget = new AddressFinder.Widget(
      this.suburb,
      gon.services.address_finder_api_key,
      'AU', {
        "show_addresses": false,
        "show_locations": true,
        "location_params": {
          "location_types": "locality"
        },
        container: this.selectContainer,
      }
    );

    this.widget.on('result:select', (fullAddress, metaData) => {
      this.props.onChange(metaData)
      this.suburb.value = metaData.full_location
    });
  }

  onChange(value) {
    if (value.length == 0) {
      this.props.onChange({
        locationAddress: null,
      })
    }
  }

  initializeFinder() {
    if (this.widget == undefined && this.suburb && this.selectContainer) {
      this.suburbFinder()
    }
  }

  componentDidMount() {
    this.initializeFinder()
  }

  componentDidUpdate() {
    this.initializeFinder()
  }

  render() {
    const { errorMessage } = this.props

    return(
      <div className='form-group form-group-lg'>
        <label>Please enter a suburb</label>
        <input
          className={`form-control form-control-lg ${presenceErrorClass(errorMessage)}`}
          id='suburb-finder'
          ref={suburb => { this.suburb = suburb } }
          type="text"
          placeholder="e.g. DARLINGHURST NSW"
          onChange={ (e) => this.onChange(e.currentTarget.value) }
        />
        <div className="invalid-feedback">
          { errorMessage }
        </div>
        <div ref={ el => { this.selectContainer = el }} className='address-select-container' />
      </div>
    )
  }
}

export default SuburbLookup;
